export const stations_6_22 = ['GWL', 'KOAA', 'VGLB', 'SDAH']